"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorHandler = void 0;
const axios_1 = __importDefault(require("axios"));
const react_toastify_1 = require("react-toastify");
const useLocale_1 = require("../../hooks/useLocale/useLocale");
axios_1.default.isAxiosError;
const error_helpers_1 = require("../../core/errors/error.helpers");
const messages_1 = require("../../core/i18n/messages");
const SESSION_NOT_ACTIVE_MESSAGE = 'Session is not active';
const TOKEN_IS_MISSING_MESSAGE = 'Token is missing';
const useErrorHandler = () => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const getErrorMessage = (error, omitAPIErrorMessage) => {
        const unknownError = (0, error_helpers_1.getUnknownError)(error);
        const errorAppMessageKey = (0, error_helpers_1.getErrorMessageKey)(unknownError);
        const unhandledErrorMessage = formatMessage({ id: messages_1.AppMessages[errorAppMessageKey] });
        if (!omitAPIErrorMessage && axios_1.default.isAxiosError(error) && Array.isArray(error.response?.data.message)) {
            return error.response?.data.message.join(', ') || unhandledErrorMessage;
        }
        else if (!omitAPIErrorMessage && axios_1.default.isAxiosError(error) && typeof error.response?.data.message === 'string') {
            return error.response?.data.message || unhandledErrorMessage;
        }
        else {
            return unhandledErrorMessage;
        }
    };
    const handleError = ({ error, omitAPIErrorMessage, updateToastCallback, omitErrorCodes, }) => {
        if (axios_1.default.isAxiosError(error) && error.response?.status && omitErrorCodes?.includes(error.response.status))
            return;
        const errorMessage = getErrorMessage(error, omitAPIErrorMessage);
        // Don't show toast for session not active messages - these should trigger logout flow instead
        if (errorMessage === SESSION_NOT_ACTIVE_MESSAGE) {
            return;
        }
        // Don't show toast for "Token is missing" messages - these occur during normal autologout scenarios
        if (errorMessage === TOKEN_IS_MISSING_MESSAGE) {
            return;
        }
        // Don't show generic "Authentication failed" for 401s that should be handled by refresh interceptor
        if (axios_1.default.isAxiosError(error) && error.response?.status === 401 &&
            !errorMessage.includes('Session is not active') &&
            !errorMessage.includes('Token is missing')) {
            // Let the refresh interceptor handle 401s unless it's a specific auth error
            return;
        }
        if (updateToastCallback) {
            return updateToastCallback(errorMessage);
        }
        else {
            return react_toastify_1.toast.dark(errorMessage, { toastId: errorMessage });
        }
    };
    return { handleError, getErrorMessage };
};
exports.useErrorHandler = useErrorHandler;
